const purge = {
  annualPurge: "Jährliche Bereinigung",
  annualDataPurge: "Jährliche Datenbereinigung",
  purgeWarning:
    "Die Bereinigung löscht alle Anwendungsdaten, die mit persönlichen Konten, Klassen, Aufgaben und Schulen verknüpft sind.",
  purgeIrreversible:
    "Diese Aktion ist irreversibel und muss im Rahmen der jährlichen Bereinigung durch das GAR am 15. August erfolgen.",
  purgeToConfirm:
    "Zur Bestätigung geben Sie bitte im folgenden Feld ein: „Ich bestätige, dass ich die Daten bereinigen möchte“",
  launchPurge: "Bereinigung starten",
};

export default purge;
